import nfmImage from "../assets/images/nfm.jpeg"
import arrowImage from "../assets/images/arrow.png"
import whatNfm from "../assets/images/whatnfm.jpeg"
import howNfm from "../assets/images/mining.jpg"
import backImages from "../assets/images/back.jpeg"
import firstnft from "../components/pages/images/iconic.jpeg"
import secondnft from "../components/pages/images/premium.jpeg"
import thirdnft from "../components/pages/images/toplocation.jpeg"
import mining from "../components/pages/images/mining.jpg"
import sold from "../assets/images/sold.jpeg"
import Logo from "../assets/images/Logo.png"
import GlowLine from "../assets/images/Glow.png"
import staking from "../assets/images/staking.jpg"
import swapping from "../assets/images/swapping.jpg"
import iconicCardImage from "../assets/images/Iconic.png"
import topCardImage from "../assets/images/Top.png"
import forwardArrowIcon from "../assets/images/forwardArrow.svg"
import backwardArrowIcon from "../assets/images/backwardArrow.svg"
import tick from "../assets/images/tick.svg"
import nitroLogo from "../components/pages/images/images/LOGO2.png"
import homeIcon from "../components/pages/images/images/icons/Home.png"
import nfmIcon from "../components/pages/images/images/icons/nfm.png"
import pendingpaymentIcon from "../components/pages/images/images/icons/pendingpayment.png"
import myActivityIcon from "../components/pages/images/images/icons/myactivity.png"
import myCollectionIcon from "../components/pages/images/images/icons/mycollection.png"
import cartIcon from "../components/pages/images/images/icons/cart.png"
import myNestIcon from "../components/pages/images/images/icons/mynest.png"
import myRewardIcon from "../components/pages/images/images/icons/myreward.png"
import logoutIcon from "../components/pages/images/images/icons/Login.png"
import deviceManageIcon from "../components/pages/images/images/icons/deviceManagementIcon.png"
import emiIcon from "../components/pages/images/images/icons/Emi.png"
// Tier
import iconic from "../components/pages/images/images/iconic.jpeg"
import premium from "../components/pages/images/images/premium.jpeg"
import top from "../components/pages/images/images/top.jpeg"

import iconicMarketplace from "../components/pages/images/marketplace/iconic.png"
import premiumMarketplace from "../components/pages/images/marketplace/premium.png"
import topMarketplace from "../components/pages/images/marketplace/top.png"
import bannerMarketplace from "../components/pages/images/marketplace/banner.png"
import banner2Marketplace from "../components/pages/images/marketplace/banner2.png"

// User
import user from "../components/pages/images/images/user.jpg"

// Sold NFM Images
import tier11 from "../assets/images/NFMs/tier11.png"
import tier12 from "../assets/images/NFMs/tier12.png"
import tier13 from "../assets/images/NFMs/tier13.png"
import tier21 from "../assets/images/NFMs/tier21.png"
import tier22 from "../assets/images/NFMs/tier22.png"
import tier23 from "../assets/images/NFMs/tier23.png"
import tier24 from "../assets/images/NFMs/tier24.png"
import tier25 from "../assets/images/NFMs/tier25.png"
import tier26 from "../assets/images/NFMs/tier26.png"
import tier27 from "../assets/images/NFMs/tier27.png"
import tier31 from "../assets/images/NFMs/tier31.png"
import tier32 from "../assets/images/NFMs/tier32.png"
import tier33 from "../assets/images/NFMs/tier33.png"

// Social Icons fb, insta, twitch, twitter, medium, discord
import facebook from "../assets/images/facebook.png"
import instagram from "../assets/images/instagram.png"
import twitch from "../assets/images/twitch.png"
import twitter from "../assets/images/twitter.png"
import discord from "../assets/images/discord.png"
import medium from "../assets/images/medium.png"

// Logos Media partners
import coinTelegraph from "../assets/images/cointelegraph.png"
import investorObserver from "../assets/images/investorObserver.png"
import yahooFinance from "../assets/images/yahooFinance.png"
import topBanner from "../assets/images/top_banner.jpeg"
import HexMapSidebarBackground from "../assets/images/HexMapSidebarBackground.png"

//homepage
import offer1 from "../components/pages/images/home/offer1.png"
import offer2 from "../components/pages/images/home/offer2.png"
import offer3 from "../components/pages/images/home/offer3.png"
import ourTechStack from "../components/pages/images/home/ourTechStack.png"
import techStackMobile from "../components/pages/images/home/techStackMobile.png"
import bot1 from "../components/pages/images/home/bot1.png"
import bot2 from "../components/pages/images/home/bot2.png"
import bot3 from "../components/pages/images/home/bot3.png"
import bot4 from "../components/pages/images/home/bot4.png"
import litepaper from "../components/pages/images/home/Lite-paper.png"
import whitepaper from "../components/pages/images/home/White-paper.png"
import nitrodoc from "../components/pages/images/home/Nitro-doc.png"
import iotWhitepaper from "../components/pages/images/home/iotWhitepaper.png"
import ncashCircle from "../components/pages/images/home/ncashCircle.png"
import contactSvg from "../components/pages/images/home/contactSvg.png"
import slide1 from "../components/pages/images/home/slide1.png"
import slide2 from "../components/pages/images/home/slide2.jpg"
import slide3 from "../components/pages/images/home/slide3.png"
import avalance from "../components/pages/images/home/Logos/avalance.png"
import pangolin from "../components/pages/images/home/Logos/pangolin.png"
import beefy from "../components/pages/images/home/Logos/beefy.png"
import redlight from "../components/pages/images/home/Logos/redlight.png"
import techm from "../components/pages/images/home/Logos/techm.png"
import cointelegraph2 from "../components/pages/images/home/Logos/cointelegraph.png"
import ibc from "../components/pages/images/home/Logos/ibc.png"
import investerobserver from "../components/pages/images/home/Logos/investerobserver.png"
import yahoo from "../components/pages/images/home/Logos/yahoo.png"
import tektelic from "../components/pages/images/home/Logos/tektelic.png"
import milesight from "../components/pages/images/home/Logos/milesight.png"
import dragino from "../components/pages/images/home/Logos/dragino.png"
import falconx from "../components/pages/images/home/Logos/falconx.png"
import amantya from "../components/pages/images/home/Logos/amantya.png"
import alliot from "../components/pages/images/home/Logos/alliot.png"
import enthu from "../components/pages/images/home/Logos/enthu.png"
import huobiglobal from "../components/pages/images/home/Logos/huobiglobal.png"
import playIcon from "../components/pages/images/home/Logos/play-icon.png"
// BURN PAGE
import CoinNcash from "../components/pages/images/burn/header/coin.png"

// Ncash PAGE
import Chart from "../components/pages/images/ncash/chart.png"
import MintCycle from "../components/pages/images/ncash/mintCycle.png"
import NcashUtility from "../components/pages/images/ncash/ncashUtility.png"
import NcashUtilityLarge from "../components/pages/images/ncash/ncashUtilityLarge.png"
import NCashCoin from "../components/pages/images/ncash/header/Ncash-small.png"
import NCashCoinLarge from "../components/pages/images/ncash/header/Ncash-large.png"
import NCashCoinSmaller from "../components/pages/images/ncash/header/Ncash-smaller.png"
import quick1 from "../components/pages/images/ncash/icons/quick1.svg"
import quick2 from "../components/pages/images/ncash/icons/quick2.svg"
import quick3 from "../components/pages/images/ncash/icons/quick3.svg"
import quick4 from "../components/pages/images/ncash/icons/quick4.svg"
import huobi from "../components/pages/images/ncash/icons/huobi.png"
import pangolinNcash from "../components/pages/images/ncash/icons/pangolin.png"
import medium1 from "../components/pages/images/ncash/icons/medium1.png"
import medium2 from "../components/pages/images/ncash/icons/medium2.png"
import medium3 from "../components/pages/images/ncash/icons/medium3.png"

export const Images = {
  nfmImage,
  arrowImage,
  whatNfm,
  howNfm,
  backImages,
  thirdnft,
  secondnft,
  firstnft,
  mining,
  sold,
  staking,
  swapping,
  iconicCardImage,
  topCardImage,
  tick,
  HexMapSidebarBackground,

  //sold images
  tier11,
  tier12,
  tier13,
  tier21,
  tier22,
  tier23,
  tier24,
  tier25,
  tier26,
  tier27,
  tier31,
  tier32,
  tier33,
  Logo,
  GlowLine,
  forwardArrowIcon,
  backwardArrowIcon,
  //social icons
  facebook,
  instagram,
  twitch,
  twitter,
  medium,
  discord,

  //Logos
  coinTelegraph,
  investorObserver,
  yahooFinance,
  topBanner,
  nitroLogo,
  // Icons
  homeIcon,
  pendingpaymentIcon,
  myActivityIcon,
  myCollectionIcon,
  cartIcon,
  myNestIcon,
  myRewardIcon,
  logoutIcon,
  deviceManageIcon,
  user,
  emiIcon,
  nfmIcon,
  // Tier
  iconic,
  premium,
  top,
  // MArketplace
  iconicMarketplace,
  premiumMarketplace,
  topMarketplace,
  bannerMarketplace,
  banner2Marketplace,

  //homepage
  offer1,
  offer2,
  offer3,
  ourTechStack,
  techStackMobile,
  bot1,
  bot2,
  bot3,
  bot4,
  litepaper,
  whitepaper,
  nitrodoc,
  iotWhitepaper,
  avalance,
  beefy,
  redlight,
  pangolin,
  techm,
  cointelegraph2,
  ncashCircle,
  ibc,
  investerobserver,
  yahoo,
  tektelic,
  milesight,
  dragino,
  falconx,
  amantya,
  alliot,
  enthu,
  huobiglobal,
  contactSvg,
  slide1,
  slide2,
  slide3,
  playIcon,

  // BURN
  CoinNcash,
  // NCASH

  NCashCoin,
  NCashCoinLarge,
  NCashCoinSmaller,
  quick1,
  quick2,
  quick3,
  quick4,
  Chart,
  NcashUtility,
  NcashUtilityLarge,
  huobi,
  pangolinNcash,
  MintCycle,
  medium1,
  medium2,
  medium3
}
